import styles from './Benefits.module.scss';
import {
  DRUG_FREE_ICON,
  CGMP_COMPLIANT,
  DISTILLED_OMEGA_3,
  GLUTEN_FREE,
  MANUFACTURED_FDA_REGISTERED,
  NATURAL_INGREDIENTS,
  NO_ARTIFICIAL_DYE,
  NO_HEAVY_METAL,
  NO_HIGH_FRUCTOSE,
  NON_GMO,
  NON_HABIT_FORMING,
  NO_SUGAR_SWEETENER,
  TESTED_USA,
  THIRD_PARTY_PURITY_POTENCY,
  VEGETARIAN,
} from '../../../../../commons/components/ui/SvgIcons';
import { ProductsCategory } from '../../../../../config';

function Benefits({ productType = ProductsCategory.RELIEF_FACTOR }) {
  const iconColor = '#004152';
  const badgeData = {
    [ProductsCategory.RELIEF_FACTOR]: [
      {
        icon: <DRUG_FREE_ICON fill={iconColor} height={40} />,
        text: '100% Drug-free',
      },
      {
        icon: <NATURAL_INGREDIENTS fill={iconColor} height={40} />,
        text: 'Natural Ingredients',
      },
      {
        icon: <CGMP_COMPLIANT fill={iconColor} height={40} />,
        text: 'cGMP Compliant',
      },
      {
        icon: <NO_HEAVY_METAL fill={iconColor} height={40} />,
        text: 'No Heavy Metals',
      },
      {
        icon: <MANUFACTURED_FDA_REGISTERED fill={iconColor} height={40} />,
        text: 'Manufactured in FDA-registered Facility',
      },
      {
        icon: <THIRD_PARTY_PURITY_POTENCY fill={iconColor} height={40} />,
        text: '3rd Party Tested for Purity and Potency',
      },
      {
        icon: <GLUTEN_FREE fill={iconColor} height={40} />,
        text: 'Gluten-free',
      },
      {
        icon: <DISTILLED_OMEGA_3 fill={iconColor} height={40} />,
        text: 'Distilled Omega-3',
        types: [],
      },
    ],
    [ProductsCategory.GO_FACTOR]: [
      {
        icon: <DRUG_FREE_ICON fill={iconColor} height={40} />,
        text: '100% Drug-free',
      },
      {
        icon: <NATURAL_INGREDIENTS fill={iconColor} height={40} />,
        text: 'Natural Ingredients',
      },
      {
        icon: <CGMP_COMPLIANT fill={iconColor} height={40} />,
        text: 'cGMP Compliant',
      },
      {
        icon: <NO_HEAVY_METAL fill={iconColor} height={40} />,
        text: 'No Heavy Metals',
      },
      {
        icon: <MANUFACTURED_FDA_REGISTERED fill={iconColor} height={40} />,
        text: 'Manufactured in FDA-registered Facility',
      },
      {
        icon: <THIRD_PARTY_PURITY_POTENCY fill={iconColor} height={40} />,
        text: '3rd Party Tested for Purity and Potency',
      },
      {
        icon: <GLUTEN_FREE fill={iconColor} height={40} />,
        text: 'Gluten-free',
      },
    ],
    [ProductsCategory.ZEN_FACTOR]: [
      {
        icon: <DRUG_FREE_ICON fill={iconColor} height={40} />,
        text: '100% Drug-free',
      },
      {
        icon: <NATURAL_INGREDIENTS fill={iconColor} height={40} />,
        text: 'Natural Ingredients',
      },
      {
        icon: <CGMP_COMPLIANT fill={iconColor} height={40} />,
        text: 'cGMP Compliant',
      },
      {
        icon: <NO_HEAVY_METAL fill={iconColor} height={40} />,
        text: 'No Heavy Metals',
      },
      {
        icon: <MANUFACTURED_FDA_REGISTERED fill={iconColor} height={40} />,
        text: 'Manufactured in FDA-registered Facility',
      },
      {
        icon: <THIRD_PARTY_PURITY_POTENCY fill={iconColor} height={40} />,
        text: '3rd Party Tested for Purity and Potency',
      },
      {
        icon: <GLUTEN_FREE fill={iconColor} height={40} />,
        text: 'Gluten-free',
      },
    ],
    [ProductsCategory.Z_FACTOR]: [
      {
        icon: <DRUG_FREE_ICON fill={iconColor} height={40} />,
        text: '100% Drug-free',
      },
      {
        icon: <CGMP_COMPLIANT fill={iconColor} height={40} />,
        text: 'cGMP Compliant',
      },
      {
        icon: <NO_HEAVY_METAL fill={iconColor} height={40} />,
        text: 'No Heavy Metals',
      },
      {
        icon: <MANUFACTURED_FDA_REGISTERED fill={iconColor} height={40} />,
        text: 'Manufactured in FDA-registered Facility',
      },
      {
        icon: <THIRD_PARTY_PURITY_POTENCY fill={iconColor} height={40} />,
        text: '3rd Party Tested for Purity and Potency',
      },
      {
        icon: <GLUTEN_FREE fill={iconColor} height={40} />,
        text: 'Gluten-free',
      },
    ],
  };

  return (
    <div className={styles.benefitsWrapper}>
      <div className={styles.container}>
        {badgeData[productType].map((item) => (
          <div key={item.text} className={styles.iconContainer}>
            {item.icon}
            <h4 className={styles.title}>{item.text}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Benefits;
